module.exports = __webpack_public_path__ + "assets/bug.dffdc045.svg";